import type { SessionUser } from "@/lib/authClient";

export function canCreateGalleryContent(
	user: SessionUser | null | undefined,
): boolean {
	if (!user) return false;
	if (user.role === "admin") return true;
	return user.role === "staff" && Boolean(user.section);
}
